import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  connect() {
    // Stimulus needs a common ancestor, which we can't provide, given that table
    // elements are not allowed to have other childs than table elements.
    const inputs = this.element
      .closest("tbody")
      .nextElementSibling.querySelectorAll("select[name*=action]")

    this.element.addEventListener("change", () => {
      inputs.forEach((input) => (input.value = this.element.value))
    })
  }
}
